export const email = new RegExp(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]+$/i);

export const HEX_REGEX = /^#[0-9A-F]{6}$/i;

export const VALIDATE_HEX_REGEX = /^#([0-9A-F]{6}|[0-9A-F]{8})$/i;

export const HEX_CODE_REGEX =
  /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{8}|[A-Fa-f0-9]{3})$/;

export const uuidRegex = new RegExp(/^[0-9a-fA-F]{8}$/);
